import { useQuery } from "@tanstack/react-query";

import { TOOL_REGISTRY_VERSIONS_KEY } from "./cache-utils";
import type { ToolVersionRecord } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface GetToolVersionResponse {
  success: boolean;
  version: ToolVersionRecord;
}

export const useGetToolVersion = (
  workspaceId: number | null,
  toolId: number | null,
  versionNumber: number | null,
) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: [TOOL_REGISTRY_VERSIONS_KEY, workspaceId, toolId, "version", versionNumber],
    queryFn: async (): Promise<GetToolVersionResponse> => {
      if (!workspaceId || !toolId || !versionNumber) {
        throw new Error("Missing workspace, tool, or version number");
      }
      const res = await fetch(ENDPOINTS.tool_registry.version(workspaceId, toolId, versionNumber), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!toolId && !!versionNumber && !!userToken,
  });
};
